'use client';

import React from 'react';
import { Calendar, Users, Tag, Coins, Bell } from 'lucide-react';

interface ProductsHeaderProps {
  productsCount: number;
}

export default function ProductsHeader({ productsCount }: ProductsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2">
      {/* Título y Conteo */}
      <div className="flex items-center gap-2">
        <h1 className="text-2xl md:text-[26px] font-bold text-slate-900 tracking-tight">
          Gestionar productos
        </h1>
        <span className="text-slate-500 font-semibold text-lg">
          {productsCount}
        </span>
      </div>

      {/* Accesos rápidos circulares */}
      <div className="flex items-center gap-2 self-end sm:self-center">
        <button 
          className="w-9 h-9 rounded-full bg-white border border-slate-200/90 text-slate-600 hover:text-emerald-700 hover:border-slate-300 flex items-center justify-center transition shadow-sm"
          title="Bonificaciones"
        >
          <Coins className="w-4 h-4" />
        </button>
        <button 
          className="w-9 h-9 rounded-full bg-white border border-slate-200/90 text-slate-600 hover:text-emerald-700 hover:border-slate-300 flex items-center justify-center transition shadow-sm"
          title="Calendario"
        >
          <Calendar className="w-4 h-4" />
        </button>
        <button 
          className="w-9 h-9 rounded-full bg-white border border-slate-200/90 text-slate-600 hover:text-emerald-700 hover:border-slate-300 flex items-center justify-center transition shadow-sm"
          title="Clientes"
        >
          <Users className="w-4 h-4" />
        </button>
        <button 
          className="w-9 h-9 rounded-full bg-white border border-slate-200/90 text-slate-600 hover:text-emerald-700 hover:border-slate-300 flex items-center justify-center transition shadow-sm"
          title="Promociones"
        >
          <Tag className="w-4 h-4" />
        </button>

        {/* Notificaciones con Badge */}
        <div className="relative pl-1">
          <button className="w-9 h-9 rounded-full bg-white border border-slate-200/90 text-slate-600 hover:text-slate-900 flex items-center justify-center transition shadow-sm">
            <Bell className="w-4 h-4" />
          </button>
          <span className="absolute top-0 right-0 w-4 h-4 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
            3
          </span>
        </div>
      </div>
    </div>
  );
}
